       <template>
  <div class="footer" v-if="isShowFooter()">
    <div class="footer_container">
      <router-link tag="div" :to="{ path:'/dashboard'}" class="home_icon" exact>
        <div class="home">
          <i class="material-icons">home</i>{{$t('home')}}
        </div>
      </router-link>
      <router-link tag="div" :to="{ path:'/my-profile'}" class="home_icon">
        <div class="home profile_icon">
          <i class="material-icons">person</i>
          {{$t('profile')}}
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    isShowFooter() {
      if ((this.$route.path == "/fan-details") ||  (this.$route.path == "/accepted-message")){
        
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>
